import type { OrderListApiData } from '@navio/nsdk';
import { filterUnitFor } from 'noddi-ui-web';

export type OrderListFilterInput = Omit<
  NonNullable<OrderListApiData['query']>,
  'pageIndex' | 'pageSize' | 'ordering' | 'search'
>;

/** Orders list unit factory, for the department scope each caller adds. */
export const orderFilterUnit = filterUnitFor<OrderListFilterInput>();
